import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalProvider,
} from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import App from "./components/App";
import LoginPage from "./components/LoginPage/LoginPage";
import { createRoot } from "react-dom/client";
import { msalConfig } from "./auth/authConfig";
import "./index.scss";

const container = document.getElementById("root")!;
const root = createRoot(container);
const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </MsalProvider>
  </React.StrictMode>
);
